import type { ISettings, IPlacementData } from './types'

export const getProductSettings = async (
  accountId: string,
  productId: string,
): Promise<IPlacementData | null> => {
  const endpoint = import.meta.env.VITE_PRODUCT_SETTINGS_URL
  const query = `${accountId}/${productId}`
  const response = await fetch(endpoint + query, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  try {
    const responseJson: IPlacementData = await response.json()

    if (!response.ok) {
      throw new Error('API Error')
    }

    console.log(responseJson)
    return responseJson
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getVehiclesList = async () => {
  const endpoint = import.meta.env.VITE_VEHICLES_LIST_URL
  const query = "?q=((account_id:777))&facet.make_model_sidebar={'sort':'bucket','size':10000}&size=0"
  const response = await fetch(endpoint + query, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  try {
    const responseJson = await response.json()
    return responseJson
  } catch (error) {
    console.error(error)
    return null
  }
}
